import { useId, useState, type ReactNode } from 'react'
import { sx } from '../lib/sx'

const HEADER_TEXT =
  'font-size:var(--fs-2xs);font-weight:var(--fw-medium);color:var(--text-secondary);' +
  'letter-spacing:.06em;text-transform:uppercase'

/**
 * Collapsed-by-default section, for reference material that would otherwise
 * crowd out the controls. The whole header row is the toggle.
 */
export function Disclosure({
  label,
  children,
  defaultOpen = false,
}: {
  label: string
  children: ReactNode
  defaultOpen?: boolean
}) {
  const [open, setOpen] = useState(defaultOpen)
  const id = useId()

  return (
    <div style={sx('display:flex;flex-direction:column;gap:8px')}>
      <button
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-controls={id}
        style={sx(
          'display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;' +
            'padding:0;border:none;background:transparent;cursor:pointer;text-align:left;' +
            `font-family:inherit;color:var(--text-primary);${HEADER_TEXT}`
        )}
      >
        {label}
        <span
          style={sx(
            'width:14px;height:14px;flex:none;background:var(--text-secondary);' +
              `transform:rotate(${open ? 90 : 0}deg);transition:transform 150ms var(--ease-out);` +
              '-webkit-mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat;' +
              'mask:url(/assets/icons/arrow-right.svg) center/contain no-repeat'
          )}
        />
      </button>

      {open ? <div id={id}>{children}</div> : null}
    </div>
  )
}
